export const resetPasswordEn = {};

export const resetPasswordFr = {};
